<template>
	<div class="omapi-codebox">
		<div v-if="$slots.helpText" class="omapi-codebox__help">
			<slot name="helpText"></slot>
		</div>
		<common-tooltip
			trigger="click"
			:class="{ 'omapi-has-tooltip__no-arrow': copied }"
			:icon="false"
			:tooltip="tooltipText"
			:force-show="showCopyTooltip"
		>
			<div ref="toFocus" tabindex="0" class="omapi-codebox__copy" @click.prevent="copyValue">
				<span
					class="omapi-codebox__code"
					@mouseover="showCopyTooltip = true"
					@mouseleave="showCopyTooltip = false"
				>
					<slot />
				</span>
				<span
					class="omapi-codebox__copy-icon"
					@mouseover="showCopyTooltip = true"
					@mouseleave="showCopyTooltip = false"
				>
					<i class="fa fa-clone" :alt="buttonText"></i>
				</span>
			</div>
		</common-tooltip>
	</div>
</template>

<script lang="js">
import { copy } from '@/components/mixins/copy';

export default {
	mixins: [copy],
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

.omapi-codebox {
	background-color: $codebox_background-color;
	border-radius: $codebox_border-radius;
	padding: 25px;
	font-size: 13px;
	color: $codebox_color-help;
	line-height: $codebox_line-height;
	cursor: default;

	&__help {
		margin-bottom: 12px;
	}

	&__copy {
		display: inline-flex;

		&:focus {
			box-shadow: 0 0 0 1px #007cba;
			outline: 2px solid transparent;
			border-radius: $codebox_border-radius;
		}

		span {
			border: solid 1px $color_grey-light;
			border-radius: $codebox_border-radius;
			padding: 16px;
			background-color: $color_white;
			font-weight: $font_bold;
			cursor: copy;

			&.omapi-codebox__copy-icon {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				border-left: none;
				color: $color_grey-icon-dark;
				font-size: 20px;
				.fa {
					font-weight: $font_bold;
				}
			}

			&.omapi-codebox__code {
				color: $color_black;
				font-family: $font-family-code;
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
			}
		}
	}
}
</style>
